module.exports = __webpack_public_path__ + "media/invite/sort-down-9992d607.svg";